import { AgGrid, Link, Text } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { documentLink, emptyCell } from "./styles_vanilla.css";
import { DocumentInfo, FatcaCrsRowItem } from "./types";

const getDocumentName = (documentId: number, documents: DocumentInfo[]): string | null => {
  const doc = documents.find((d) => d.id === documentId);
  return doc?.name ?? null;
};

export const EmptyCell = () => (
  <div className={emptyCell}>
    <Text>--</Text>
  </div>
);

export type DocumentCellRendererProps = {
  params: AgGrid.ICellRendererParams<FatcaCrsRowItem>;
  isApplicable: boolean;
  documents: DocumentInfo[];
  caseId: number;
};

export const DocumentCellRenderer = ({
  params,
  isApplicable,
  documents,
  caseId,
}: DocumentCellRendererProps) => {
  if (!isApplicable || !params.data) {
    return <EmptyCell />;
  }

  const documentName = getDocumentName(params.data.documentId, documents);
  if (!documentName) {
    return <EmptyCell />;
  }

  return (
    <Link
      className={documentLink}
      to={`${globalEnv.complianceRoute}/case/${caseId}/document-management?documentId=${params.data.documentId}`}
    >
      {documentName}
    </Link>
  );
};
